import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { UserData } from 'src/app/Services/data.model';
import { ReportNotificationService } from './reportNotification.service';

@Injectable({
  providedIn: 'root'
})
export class AdmissionApiService {
  public subjectsData: { [url: string]: any } = {};
  private inFlightSubjectCache: { [url: string]: Observable<any> } = {};

  public clearSubjectsData() {
    this.subjectsData = {};
    this.inFlightSubjectCache = {};
  }

  private handleSubjectCache<T>(url: string, httpCall: Observable<T>): Observable<T> {
    if (this.subjectsData[url]) {
      return of(this.subjectsData[url]);
    }
    if (!this.inFlightSubjectCache[url]) {
      this.inFlightSubjectCache[url] = httpCall.pipe(
        tap({
          next: res => {
            this.subjectsData[url] = res;
            delete this.inFlightSubjectCache[url];
          },
          error: () => {
            delete this.inFlightSubjectCache[url];
          }
        }),
        shareReplay(1)
      );
    }
    return this.inFlightSubjectCache[url];
  }
  viewTransaction(id: any) {
    throw new Error('Method not implemented.');
  }
  editTransaction(formData: any) {
    throw new Error('Method not implemented.');
  }

  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService, private reportNotificationService: ReportNotificationService) { }
  odPayDomain: string = "https://api.okiedokiepay.com";

  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'admission')
    return FinalURL; 
  }
  
  ///////Other Module API......
  listCommunicationTemplate(entityId, eventType, channel):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/communicationTemplate?entity='+entityId+'&eventType='+eventType+ '&channel='+channel))
  }
  viewFeeMasterData(entityId, session): Observable<UserData>{
    let url = this.URLAddress('/view/feeMaster?entity=' +entityId+'&session='+session);
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  getCourseList(entityId, session,isLeet): Observable<UserData[]>{
    let queryParams = entityId+'&session='+session
    if(isLeet){
      queryParams = queryParams+"&isLEET="+isLeet
    }
    let url = this.URLAddress('/list/course?entity=' +queryParams);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  getCourseData(entityId): Observable<UserData>{
    let url = this.URLAddress('/view/course?id='+entityId);
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  listPartnerCompany(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/partnerCompany?entity='+entityId))
  }
  listPartnerInstitute(entityId): Observable<UserData[]>{
    let url = this.URLAddress('/list/partnerInstitute?entity='+entityId);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  getSessionList(entityId): Observable<UserData[]>{
    let url = this.URLAddress('/list/session?entity=' +entityId);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  viewStudentMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/studentMaster?entity='+entityId+ '&session='+ session))
  }
  listEmployee(entityId, role): Observable<UserData[]>{
    let queryParams = entityId;
    if(role){
      queryParams = queryParams + '&role='+role;
    }
    let url = this.URLAddress('/list/Employee?entity='+queryParams);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  viewAdmissionMaster(entityId, session): Observable<UserData>{
    let url = this.URLAddress('/view/admissionMaster?entity='+entityId+ '&session='+ session);
    if (!window.location.href.includes('admission/studentData')) {
      delete this.subjectsData[url];
    }
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  editAdmissionMaster(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionMaster'), formData)
  }
  checkAdmissionHeadUsage(entityId, session, admissionHead): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkAdmissionHeadUsage/admissionMaster?entity=' + entityId + '&session=' + session + '&admissionHead=' + encodeURIComponent(admissionHead)));
  }
  checkAdmissionStageUsage(entityId, session, stage): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkAdmissionHeadUsage/admissionMaster?entity=' + entityId + '&session=' + session + '&stage=' + encodeURIComponent(stage)));
  }
  private clearAdmissionStageSetupCache(entityId, session, id?) {
    if (entityId && session) {
      const listUrl = this.URLAddress('/list/admissionStageSetup?entity=' + entityId + '&session=' + session);
      delete this.subjectsData[listUrl];
      delete this.inFlightSubjectCache[listUrl];
    }
    if (id) {
      const viewUrl = this.URLAddress('/view/admissionStageSetup?id=' + id);
      delete this.subjectsData[viewUrl];
      delete this.inFlightSubjectCache[viewUrl];
    }
  }
  listAdmissionStageSetup(entityId, session): Observable<UserData[]>{
    let url = this.URLAddress('/list/admissionStageSetup?entity='+entityId+'&session='+session);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  addAdmissionStageSetup(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/admissionStageSetup'), formData).pipe(
      tap(() => this.clearAdmissionStageSetupCache(formData.entity, formData.session))
    );
  }
  viewAdmissionStageSetup(id): Observable<UserData>{
    let url = this.URLAddress('/view/admissionStageSetup?id='+id);
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  editAdmissionStageSetup(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionStageSetup'), formData).pipe(
      tap(() => this.clearAdmissionStageSetupCache(formData.entity, formData.session, formData._id))
    );
  }
  listAdmissionStudentData(formData): Observable<UserData>{
    // let queryParams = entityId +'&session='+session;
    // if(stage && stage!=''){
    //   queryParams = queryParams + '&stage='+stage
    // }
    // if(course){
    //   queryParams = queryParams + '&course='+course
    // }
    // if(stream){
    //   queryParams = queryParams + '&stream='+stream
    // }
    // if(batch){
    //   queryParams = queryParams + '&batch='+batch
    // }

    // if(startDate){
    //   queryParams = queryParams + '&startDate='+startDate
    // }
    // if(endDate){
    //   queryParams = queryParams + '&endDate='+endDate
    // }
    // if(updatedAtStartDate){
    //   queryParams = queryParams + '&updatedAtStartDate='+updatedAtStartDate
    // }
    // if(updatedAtEndDate){
    //   queryParams = queryParams + '&updatedAtEndDate='+updatedAtEndDate
    // }
    // if(counselorId){
    //   queryParams = queryParams + '&counselorId='+counselorId
    // }
    // if(tag){
    //   queryParams = queryParams + '&tag='+tag
    // }
    // if(source){
    //   queryParams = queryParams + '&source='+source
    // }
    // if(searchBy){
    //   queryParams = queryParams + '&searchBy='+searchBy
    // }
    // if(search){
    //   queryParams = queryParams + '&search='+search
    // }
    // if(pageSize){
    //   queryParams = queryParams + '&pageSize='+pageSize
    // }
    // if(pageNumber){
    //   queryParams = queryParams + '&pageNumber='+pageNumber
    // }
    // if(noCounselor!=undefined)
    //   {
    //     queryParams = queryParams+'&noCounselor='+noCounselor
    //   }

    return this.http.post<UserData>(this.URLAddress('/list/admissionStudentData'),formData)
  }
  listAdmissionStudentDataMobile(formData): Observable<UserData>{
    // let queryParams = entityId +'&session='+session;
    // if(searchBy){
    //   queryParams = queryParams + '&searchBy='+searchBy
    // }
    // if(search){
    //   queryParams = queryParams + '&search='+search
    // }
    return this.http.post<UserData>(this.URLAddress('/list/admissionStudentData'),formData)
  }
  addAdmissionStudentData(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/admissionStudentData'), formData)
  }
  addToStudent(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/addToStudent/admissionStudentData'), formData)
  }
  viewAdmissionStudentData(id): Observable<UserData>{
    let url = this.URLAddress('/view/admissionStudentData?id='+id);
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  editAdmissionStudentData(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionStudentData'), formData).pipe(
      tap(() => {
        let url = this.URLAddress('/view/admissionStudentData?id='+formData._id);
        delete this.subjectsData[url];
      })
    );
  }
  moveAdmissionStudentData(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/moveStudentToEntity/admissionStudentData'), formData)
  }
  saveAdmissionTransaction(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/admissionTransaction'), formData)
  }
  retryAdmissionVoucher(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/reCreate/accountingVoucher?id='+id+'&txnType=admission' ));
  }
  viewAdmissionTransactionList(entityId, session, studentId): Observable<UserData[]>{
    let queryParams = entityId+'&session='+session;
    if(studentId){
      queryParams = queryParams+'&studentData='+studentId
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/admissionTransaction?entity='+queryParams))
  }
  listAdmissionTransaction(entityId, session, startDate, endDate, status,voucherStatus,search): Observable<UserData[]>{
    let queryParms = entityId+ '&session=' +session;
    if(startDate){
      queryParms = queryParms + '&startDate=' +startDate;
    }
    if(endDate){
      queryParms = queryParms + '&endDate=' +endDate;
    }
    if(status){
      queryParms = queryParms + '&status=' +status;
    }
    if(voucherStatus)
    {
      queryParms = queryParms + '&voucherStatus=' +voucherStatus;
    }
    if(search)
    {
      queryParms = queryParms + '&search=' +search;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/admissionTransaction?entity='+queryParms))
  }
  viewAdmissionTransaction(id): Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/admissionTransaction?id='+id))
  }
  cancelReceipt(receiptData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/cancelReceipt/admissionTransaction'),receiptData);
  }
  deleteAdmissionTransaction(transactionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/admissionTransaction?id='+transactionId));
  }
  listDailyCollectionReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyCollectionReport/admissionReports'),formData)
  }
  uploadAdmissionStudentData(entityId, session, formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadSheet/admissionStudentData?entity='+entityId+'&session='+session),formData)
  }
  deleteAdmissionStudentData(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/AdmissionStudentData?id='+id));
  }
  uploadAdmissionDocuments(id, qac, formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/uploadAdmissionDocuments?id='+id+'&qac='+qac),formData)
  }
  getAdmissionStudentDataStageCount(formData): Observable<number>{
    return this.http.post<number>(this.URLAddress('/getStageCount/admissionStudentData'),formData)
  }

  updateStudentDetailsXL(entityId, session, label, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadUpdateSheet/admissionStudentData?entity=' +entityId+'&session='+session+'&label='+label), fileData)
  }
   importAdmissionStudentTransactions(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importReceipts/admissionTransaction?entity=' +entityId+'&session='+session), fileData)
  }
  importStudentDataXL(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importSheet/admissionStudentData?entity=' +entityId+'&session='+session), fileData)
  }

  viewAdmissionSummaryReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/admissionSummary/admissionReports'),formData)
  }
  addReportFile(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/reportFile'), formData).pipe(
      tap(() => this.reportNotificationService.notifyReportGenerated())
    )
  }
  listSubjectCombination(entityId, session,course,stream): Observable<UserData[]>{
    let url = this.URLAddress('/list/subjectCombination?entity='+entityId+ '&session='+ session+ '&course='+ encodeURIComponent(course)+ '&stream='+ stream);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  listSubjectCombinationWIthBatch(entityId, session,course,stream,batch): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+ session+ '&course='+ encodeURIComponent(course)+ '&stream='+ stream
    if(batch)
    {
      queryParams +='&batch='+batch
    }
    let url = this.URLAddress('/list/subjectCombination?entity='+queryParams);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  listNepSubeject(entityId,session,course,stream,batch): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+ session+ '&course='+ encodeURIComponent(course)+ '&stream='+ stream
    if(batch)
    {
      queryParams +='&batch='+batch
    }
    let url = this.URLAddress('/list/nepSubject?entity='+queryParams);
    return this.handleSubjectCache(url, this.http.get<UserData[]>(url));
  }
  listStages(entityId, session,counselorId?): Observable<UserData[]>{
    let queryParams = entityId+'&session='+session
    if(counselorId)
    {
      queryParams +='&counselorId='+counselorId
    }
    return this.http.get<UserData[]>(this.URLAddress('/getCountByStages/admissionStudentData?entity='+queryParams))
  }

  getDataFromODpay(odPayEntityId,applicationNumber,erpSession): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/search/student",{
      entity: odPayEntityId,
      enrollmentNumber: applicationNumber,
      erpSession:erpSession,
      erpTransactionType:"admission" 
    })
  }
    viewByTxnId(txnId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewByTxnId/admissionTransaction?txnId='+txnId))
  }

  //flags
  retryRegistrationFlag(id,value):Observable<any>{
    return this.http.get<any>(this.URLAddress('/retryAnalyticsFlags/admissionStudentData?id='+id+"&flagType="+value))
  }

  copyFromSession(id,fromSession,toSession):Observable<any>{
    return this.http.get<any>(this.URLAddress('/copyFromSession/admissionStageSetup?entity='+id+"&fromSession="+fromSession+'&toSession='+toSession)).pipe(
      tap(() => this.clearAdmissionStageSetupCache(id, toSession))
    );
  }

  deleteStageSetup(id,stage,entity,session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/admissionStageSetup?id='+id+'&stage='+stage+'&entity='+entity+'&session='+session)).pipe(
      tap(() => this.clearAdmissionStageSetupCache(entity, session, id))
    );
  }

  //nep Subjects
  addNepSubject(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/nepSubject'), formData)
  }
  editNepSubject(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/nepSubject'), formData)
  }
  listNepSubjects(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/nepSubject?entity='+entityId+'&session='+session))
  }
  viewNepSubjects(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/nepSubject?id='+id));
  }
  deleteNepSubejcts(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/nepSubject?id='+id));
  }
  getStageCounselor(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/getStageCounselor/admissionStudentData'), formData)
  }
  listFollowUp(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/list/admissionFollowUp'), formData)
  }
  addAdmissionFollowUp(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/admissionFollowUp'), formData).pipe(
      tap(() => {
        if (formData.studentData) {
          let url = this.URLAddress('/view/admissionStudentData?id=' + formData.studentData);
          delete this.subjectsData[url];
        }
      })
    );
  }
  editAdmissionFollowUp(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionFollowUp'), formData).pipe(
      tap(() => {
        if (formData.studentData) {
          let url = this.URLAddress('/view/admissionStudentData?id=' + formData.studentData);
          delete this.subjectsData[url];
        }
      })
    );
  }
  deleteAdmissionFollowUp(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/admissionFollowUp?id='+id))
  }

  listAdmissionLeadLogs(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/list/admissionLeadLogs'), formData)
  }
  editAdmissionLeadLogs(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionLeadLogs'), formData)
  }
  viewAdmissionLeadLogs(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/admissionLeadLogs?id='+id));
  }
  deleteAdmissionLeadLogs(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/admissionLeadLogs?id='+id));
  }
  convertAdmissionLeadLog(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/convert/admissionLeadLogs'),formData);
  }
  addAdmissionLogs(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/admissionLeadLogs'),formData).pipe(
      tap(() => {
        if (formData.studentData) {
          let url = this.URLAddress('/view/admissionStudentData?id=' + formData.studentData);
          delete this.subjectsData[url];
        }
      })
    );
  }
  clickToCall(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/peerToPeerCall/admissionLeadLogs'),formData)
  }
  counselorLeadReport(entity,session,stageType,counselorId,startDate,endDate,course,stream,source): Observable<UserData[]>{
    let queryParams = entity+'&session='+session+'&stageType='+stageType;
    if(startDate)
      {
        queryParams+='&startDate='+startDate;
      }
      if(endDate)
        {
          queryParams+='&endDate='+endDate
        }
        if(counselorId)
          {
            queryParams+='&counselorId='+counselorId
          }
        if(course)
          {
            queryParams+='&course='+course
          }
        if(stream)
          {
            queryParams+='&stream='+stream
          }
        if(source)
          {
            queryParams+='&source='+source
          }
    return this.http.get<UserData[]>(this.URLAddress('/counselorProductivity/admissionReports?entity='+queryParams));
  }
  sourceLeadReport(formData): Observable<UserData[]>{
    // let queryParams =entity+'&session='+session+'&stageType='+stageType
    // if(startDate)
    //   {
    //     queryParams+='&startDate='+startDate;
    //   }
    //   if(endDate)
    //     {
    //       queryParams+='&endDate='+endDate
    //     }
    //     if(source && source.length>0)
    //       {
    //         queryParams+='&source='+source
    //       }
    //       if(counselorId)
    //       {
    //         queryParams +='&counselorId='+counselorId
    //       }
    return this.http.post<UserData[]>(this.URLAddress('/sourceWiseReport/admissionReports'),formData);
  }
  counselorTagList(entity,session,counselor,startDate,endDate): Observable<UserData[]>{
    let queryParams =entity+'&session='+session
    if(startDate)
      {
        queryParams+='&startDate='+startDate;
      }
      if(endDate)
        {
          queryParams+='&endDate='+endDate
        }
        if(counselor)
          {
            queryParams+='&counselorId='+counselor
          }
    return this.http.get<UserData[]>(this.URLAddress('/counselorTagReport/admissionReports?entity='+queryParams));
  }
  courseWiseTagReport(entity,session,counselor,startDate,endDate): Observable<UserData[]>{
    let queryParams =entity+'&session='+session
    if(startDate)
      {
        queryParams+='&startDate='+startDate;
      }
      if(endDate)
        {
          queryParams+='&endDate='+endDate
        }
        if(counselor)
          {
            queryParams+='&counselorId='+counselor
          }
    return this.http.get<UserData[]>(this.URLAddress('/courseTagReport/admissionReports?entity='+queryParams));
  }
  counselorStageWise(entity,session,counselor,startDate,endDate): Observable<UserData[]>{
    let queryParams =entity+'&session='+session
    if(startDate)
      {
        queryParams+='&startDate='+startDate;
      }
      if(endDate)
        {
          queryParams+='&endDate='+endDate
        }
        if(counselor)
          {
            queryParams+='&counselorId='+counselor
          }
    return this.http.get<UserData[]>(this.URLAddress('/counselorStageReport/admissionReports?entity='+queryParams));
  }
  getFilterCountFollowUp(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/filterCount/admissionFollowUp'),formData)
  }
  getCourseLists(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  editAdmissionTransaction(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/admissionTransaction'), formData)
  }
  editExcelTemplate(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/excelTemplate'), formData)
  }
  listExcelTemplate(entity,report):Observable<any[]>{
    let queryParams = entity
    if(report)
    {
      queryParams+='&report='+report
    }
    return this.http.get<any[]>(this.URLAddress('/list/excelTemplate?entity='+queryParams))
  }
  viewExcelTemplate(id): Observable<UserData>{
    let url = this.URLAddress('/view/excelTemplate?id='+id);
    return this.handleSubjectCache(url, this.http.get<UserData>(url));
  }
  viewDefaultExcelTemplates(report,entityType): Observable<UserData>{
    let queryParams
    if(report)
    {
      queryParams+='&report='+report
    }
    if(entityType)
    {
      queryParams+='&entityType='+entityType
    }
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultExcelTemplate?report='+report+'&entityType='+entityType) );
  }
  listNepSubject(entityId,session,course,stream,batch,groupBy,type): Observable<UserData[]>{

    let queryParams = entityId+'&session='+session

    if(course)
    {
      queryParams+='&course='+encodeURIComponent(course)
    }
    
    if(stream)
    {
      queryParams+='&stream='+stream
    }
    
    if(batch)
    {
      queryParams+='&batch='+batch
    }
    queryParams+="&groupBy="+groupBy+'&nepSubjectType='+type
    return this.http.get<UserData[]>(this.URLAddress('/nepSubjectReport/admissionReports?entity='+queryParams));
  }
  admissionReports(entityId,session,course,stream,batch): Observable<UserData[]>{

    let queryParams = entityId+'&session='+session

    if(course)
    {
      queryParams+='&course='+encodeURIComponent(course)
    }
    
    if(stream)
    {
      queryParams+='&stream='+stream
    }
    
    if(batch)
    {
      queryParams+='&batch='+batch
    }
    return this.http.get<UserData[]>(this.URLAddress('/subjectCombinationReport/admissionReports?entity='+queryParams));
  }
  getEntityId(entityId,branchId): Observable<any>{
    let queryParams = entityId 
  
    if(branchId){
      queryParams = queryParams + '&branchId='+branchId
    }
    return this.http.get<any>(this.odPayDomain+'/api/getEntityForERP/entity?odErpEntityId='+queryParams)
  }
  loginWithoutOTP(phone): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/loginWithoutOTP",{
      phone: phone,
    })
  }
  resetUserPasswordFromERP(userId,pass) : Observable<any>{
    return this.http.post<any>(this.odPayDomain+'/resetPasswordFromERP?userId='+userId,{
      userId:userId,
      password:pass
    })
  }
  applyCharges(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/apply/chargesCategory",formData)
  }
  recentPaymentCheck(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/recentPaymentCheck/payment",formData)
  }
  initiateTxn(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/initiateTxn/payment",formData)
  }
  processPayment(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/process/payment",formData)
  }
  viewCommunicationConfig(entityId, session):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/communicationConfig?entity='+entityId+'&session='+session))
  }  
  sendMultipleAdmissionReminderEmailCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendBulkAdmissionReminderEmail/communication'), formData)
  }   
  sendMultipleAdmissionReminderSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderSMS/communication'), formData)
  }   
  sendMultipleAdmissionReminderWhstasAppSMSCommunication(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderWhatsAppWeb/communication'), formData)
  }
  sendMultipleAdmissionReminderWhstasNewAppSMSCommunication(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderWhatsApp/communication'), formData)
  }
  sendMultipleAssessmentResultWhstasNewAppSMSCommunication(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAssessmentResultWhatsApp/communication'), formData)
  }
  viewEntityPreferences(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/entityPreferences?entity='+id))
  }
  moveApplicationData(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/moveToEntity/admissionStudentData'),formData)
  }
   moveApplicationDataToNewSession(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/moveToSession/admissionStudentData'),formData)
  }
  listStudentTransaction(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/list/transaction'),formData)
  }
  getSubjectsByCourse(entityId, session, assessmentModel, course, stream, batch, section):Observable<UserData>{
    let queryParams = 'entity='+ entityId+'&session='+session;
    if(assessmentModel){
      queryParams = queryParams + '&assessmentModel='+assessmentModel;
    }
    if(course){
      queryParams = queryParams + '&course='+encodeURIComponent(course);
    }
    if(stream){
      queryParams = queryParams + '&stream='+stream;
    }
    if(batch){
      queryParams = queryParams + '&batch='+batch;
    }
    if(section){
      queryParams = queryParams + '&section='+section;
    }
    return this.http.get<UserData>(this.URLAddress('/getSubjectsByCourse/subjectCourseMapping?'+queryParams))
  }
  viewDefaultTemplate(entity,name,course):Observable<any>{
    let queryParams = entity+'&report='+name
    if(course){
      queryParams+='&course='+encodeURIComponent(course)
    }
    let url = this.URLAddress('/viewDefault/pdfTemplate?entity='+queryParams);
    return this.handleSubjectCache(url, this.http.get<any>(url));
  }
  viewPDFDefaultTempaltes(entityType,reportName): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultPDFTemplate?report='+reportName+'&entityType='+entityType));
  }

  openViewDefaultPDFTemplates(entityType,reportName): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/openViewDefaultPDFTemplates?report='+reportName+'&entityType='+entityType));
  }
  viewCountsOfFollowUps(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/getLeadCounts/admissionStudentData?id='+id))
  }
  pushTxnToODPay(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/pushTransaction/odpay'),formData)
  }
  bulkCounselorUpdate(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/bulkUpdateCounselor/bulkRequest'),formData);
  }
  getPresignedUrl(qac,formData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/getPresignedUrl?qac="+ qac),formData);
  }
  viewPayment(receiptId):Observable<any>{
    return this.http.get<any>(this.odPayDomain+'/api/view/payment?id='+receiptId)
  }
  updateStatus(row):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateStatus/odPay'),row) 
  }
  viewCommunicationReport(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/communicationReport?id='+id));
  }
   getConcessionGroupList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/concession?entity=' +entityId+'&session='+session))
    }
  followUpRemarkReport(formData):Observable<any>{
     return this.http.post<any>(this.URLAddress('/followUpReport/admissionStudentData'),formData)
   }
}

